/**
 * Giant footer logo with a scroll-driven scale effect: full size at
 * the viewport edges, smallest when centered in the viewport, growing
 * again as it passes — driven by distance from the viewport center.
 */
class GiantLogoComponent extends HTMLElement {
  #raf = null;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.addEventListener('scroll', this.#queueUpdate, { passive: true });
    window.addEventListener('resize', this.#queueUpdate, { passive: true });
    this.#queueUpdate();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#queueUpdate);
    window.removeEventListener('resize', this.#queueUpdate);
    if (this.#raf) cancelAnimationFrame(this.#raf);
  }

  #queueUpdate = () => {
    if (this.#raf) return;
    this.#raf = requestAnimationFrame(() => {
      this.#raf = null;
      const rect = this.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      const viewportCenter = window.innerHeight / 2;
      const elementCenter = rect.top + rect.height / 2;
      // 0 at viewport center, 1 at the edges
      const t = Math.min(1, Math.abs(elementCenter - viewportCenter) / viewportCenter);
      const min = Number(this.dataset.minScale || 0.55);
      const scale = min + (1 - min) * t;
      this.style.setProperty('--giant-logo-scale', scale.toFixed(4));
    });
  };
}

if (!customElements.get('giant-logo-component')) {
  customElements.define('giant-logo-component', GiantLogoComponent);
}
